// removed by extract-text-webpack-plugin
module.exports = {"input":"_24868075","label":"_74628062","checker":"a67a2931","checked":"_4a9570fe","unchecked":"_4cbab8fd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Checkbox/index.styl
// module id = 2276
// module chunks = 39